import { AsterMark, Button } from '@head-of-trading/ui';
import { useEffect } from 'react';
import { useLanguage } from '../i18n/context.js';
import { screensCopy } from '../i18n/screens.js';

export function Intro({ onDone }: { readonly onDone: () => void }) {
  const { language } = useLanguage();
  const copy = screensCopy[language].intro;
  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const timer = window.setTimeout(onDone, reduced ? 1_200 : 6_800);
    return () => window.clearTimeout(timer);
  }, [onDone]);

  return (
    <div className="intro" role="dialog" aria-label={copy.dialogLabel}>
      <div className="intro__market-lines" aria-hidden="true">
        {Array.from({ length: 14 }, (_, index) => <i key={index} style={{ '--line': index } as React.CSSProperties} />)}
      </div>
      <div className="intro__depth" aria-hidden="true"><span /><span /><span /><span /><span /></div>
      <AsterMark className="intro__mark" />
      <p className="intro__tagline">{copy.tagline}</p>
      <Button data-testid="intro-skip" className="intro__skip" variant="quiet" onClick={onDone}>{copy.skip}</Button>
    </div>
  );
}
